import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyles = makeStyles({
  sectionTitle: {
    "&.MuiTypography-root": {
      fontFamily: "Orbitron, sans-serif",
      fontWeight: "600",
      fontSize: "7rem",
      lineHeight: "1.8",
      display: "flex",
      justifyContent: "end",
      alignItems: "end",
      minHeight: "30rem",
      paddingBottom: "10rem",
      paddingTop: "5rem",
    },
  },
});

function SectionHeader(props) {
  const classes = useStyles();
  const { sectionTitle } = props;
  return (
    <>
      <Typography className={classes.sectionTitle} variant="h1" component="div">
        {sectionTitle}
      </Typography>
    </>
  );
}

export default SectionHeader;
